import React from 'react';
import CustomExpandableTable from '../../../../../../components/table/CustomExpandableTable';
import NotInformation from '../../../../../../components/NotInformation';
import CustomButtonLink from '../../../../../../components/buttons/CustomButtonLink';
import DeleteModal from '../../../../../Modals/DeleteModal';
import UserDeductionPolicyApp from './Functionality/UserDeductionPolicyApp';
import RenderDetails from './SubComponents/UserDeductionRenderDetails';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Section displaying users with their deduction policies in an
 * expandable table. Expanding a row reveals personal deduction policies and
 * excluded global rules.
 *
 * @param {Object} props
 * @param {string} props.searchElement - Current search input value.
 * @returns {JSX.Element}
 */
const UserDeductionPolicySection = ({
    registerAction, subView, searchElement = '', searchResults, setSearchResults,
    selectForDelete, setSelectForDelete, setIsAllChecked,
}) => {
    const {
        t,
        canCreate,
        canDelete,
        columns,
        handleRowExpand,
        pagination,
        rowsPerPage,
        handleCreate,
        renderOptionsMenu,
        showDeleteModal,
        setShowDeleteModal,
        handleSubmitDelete,
        handleCheckboxChange,
        handleDeleteAll
    } = UserDeductionPolicyApp({
        registerAction,
        subView,
        searchElement,
        searchResults,
        setSearchResults,
        selectForDelete,
        setSelectForDelete,
        setIsAllChecked,
    });

    return (
        <>
            {searchResults?.content?.length > 0 ? (
                <>
                    <CustomExpandableTable
                        id = "tbl_udp_user_deductions"
                        columns={columns}
                        rows={searchResults.content}
                        renderExpandedRow={RenderDetails}
                        onRowExpand={handleRowExpand}
                        rowsPerPage={rowsPerPage}
                        renderOptionsMenu={renderOptionsMenu}
                        checkbox={canDelete}
                        selectedList={selectForDelete}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation className={"mt-4"} card={true}>
                    <div className="warning-text">
                        <p>{t('no_users_with_deduction_policy_assigned')}</p>
                    </div>
                    {canCreate && (
                        <CustomButtonLink
                            splitName={false}
                            id="btn_udps_create_link"
                            card
                            onClick={handleCreate}
                            name="create_user_deduction_policy"
                        />
                    )}
                </NotInformation>
            )}
            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    onClickFn={handleSubmitDelete}
                    data={selectForDelete}
                    isReset={setSelectForDelete}
                    isAllReset={setIsAllChecked}
                    title_modal={t('delete')}
                    element_modal={t('user_deductions')}
                    buttonCancelText="cancel"
                />
            )}
        </>
    );
};

export default UserDeductionPolicySection;
